import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { QuestionsAlerts, QuestionsState } from "../../../../Constant";
import { QUESTIONS_ALERT } from "../../../../Data/Bonus Ui/SweetAlert";

const QuestionsAlert = () => {
  const displayAlert = () => {
    SweetAlert.fire({ text: "Are you sure you want to do this?", showCancelButton: true, cancelButtonText: "Oh noez!", confirmButtonText: "Aww yess!",confirmButtonColor: "#33BFBF" });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={QuestionsAlerts} span={QUESTIONS_ALERT} />
        <CardBody className="btn-showcase">
          <Btn color="primary" className="sweet-1" type="button" onClick={displayAlert}>
            {QuestionsState}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default QuestionsAlert;
